import MemberContractState from './MemberContractState';
import ParameterValue from './ParameterValue';

export default class MemberShortProfileBasic {
    fullNameWithTitle() {
        let fullName = this.fullName;

        if (this.academicTitle) {
            fullName = `${this.academicTitle.value} ${fullName}`;
        }

        return fullName;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const member = new MemberShortProfileBasic();
        member.id = data.id;
        member.fullName = data.fullName;
        member.gender = data.gender;
        member.hasAvatar = data.hasAvatar;
        member.avatarFileName = data.avatarFileName;
        member.contractState = data.contractState ? new MemberContractState(data.contractState.status, data.contractState.contractType) : null;
        member.membershipNumber = data.membershipNumber;
        member.dateOfBirth = data.dateOfBirth;
        member.departments = data.departments;
        member.teams = data.teams;

        member.academicTitle = null;
        if (data.academicTitle && data.academicTitle.data) {
            member.academicTitle = ParameterValue.fromData(data.academicTitle.data);
        }

        return member;
    }
}
